var map = {
	"./Bash.svg": 1013,
	"./Bootstrap.svg": 6390,
	"./C++-(CPlusPlus).svg": 3417,
	"./C.svg": 8529,
	"./CLion.svg": 8737,
	"./CMake.svg": 4556,
	"./CSS3.svg": 2022,
	"./Canva.svg": 8977,
	"./Chrome.svg": 3708,
	"./CodePen.svg": 8613,
	"./Docker.svg": 816,
	"./Facebook.svg": 7944,
	"./Firebase.svg": 9112,
	"./GCC.svg": 4320,
	"./Git.svg": 8587,
	"./GitHub.svg": 4678,
	"./Google-Cloud.svg": 1736,
	"./Google.svg": 3357,
	"./HTML5.svg": 680,
	"./JSON.svg": 9646,
	"./Java.svg": 9065,
	"./JavaScript.svg": 9581,
	"./LinkedIn.svg": 7875,
	"./Linux.svg": 7359,
	"./MATLAB.svg": 7862,
	"./Material-UI.svg": 140,
	"./NPM.svg": 7598,
	"./Node.js.svg": 197,
	"./Nodemon.svg": 517,
	"./PostgresSQL.svg": 3437,
	"./Postman.svg": 6794,
	"./Powershell.svg": 6744,
	"./React-Bootstrap.svg": 6129,
	"./React.svg": 2446,
	"./SQL-Developer.svg": 2365,
	"./Sass.svg": 5767,
	"./Slack.svg": 454,
	"./Stack-Overflow.svg": 9542,
	"./Windows-11.svg": 6632,
	"./Yarn.svg": 2153
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3026;